/** @format */
import styled, { css } from 'styled-components';

import { smallMobile } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledModalFilters = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: stretch;
    justify-content: center;

    label.label,
    strong {
        ${theme.typography.body_normal_highlight};
    }

    ${smallMobile(css`
        label.label,
        strong {
            ${theme.typography.body_small};
        }

        span.text,
        .modal-filter-button {
            ${theme.typography.body_small};
        }
    `)}

    .control-group-item {
        display: flex;
        flex-grow: 1;
        flex-basis: 0;
        align-items: center;
        justify-content: center;
        padding: var(--layout-spacing-16) var(--layout-spacing-4);
        white-space: pre;
        border: 1px solid var(--colors-border-light);
        border-right: none;
        border-left: none;
        background: inherit;
    }

    .filters-count-skeleton {
        width: 5rem;
        height: 100%;
        margin-left: var(--layout-spacing-8);

        .skeleton::before {
            background: var(--colors-surface-disabled);
        }
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
